module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Disconnect RoundTable',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "flex flex-col flex-grow justify-center"
  }, [_c('div', {
    staticClass: "flex flex-row mx-auto items-center"
  }, [(_vm.integrationToDisconnect.provider_name !== 'Google Classroom') ? _c('img', {
    staticClass: "h-12 w-12",
    attrs: {
      "src": ("/static/integrations/" + (_vm.integrationToDisconnect.provider_name) + ".png")
    }
  }) : _c('img', {
    staticClass: "h-12 w-12",
    attrs: {
      "src": "/static/google_class_round.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mx-10 h-7",
    attrs: {
      "src": "/static/pass_through.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "h-12 w-12",
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": "parlay-logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-10 mx-auto"
  }, [_c('div', {
    staticClass: "flex mb-2.5"
  }, [_c('pl-checkbox', {
    model: {
      value: (_vm.removeAssignment),
      callback: function($$v) {
        _vm.removeAssignment = $$v
      },
      expression: "removeAssignment"
    }
  }), _vm._v(" "), (_vm.integrationToDisconnect.provider_name === 'Google Classroom') ? _c('span', [_vm._v("\n          Also delete the assignment from Google Classroom\n        ")]) : _c('span', [_vm._v(" Also delete the assignment from LMS integration ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('pl-checkbox', {
    model: {
      value: (_vm.removeStudents),
      callback: function($$v) {
        _vm.removeStudents = $$v
      },
      expression: "removeStudents"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n          Also remove students from\n          "), (_vm.activityType === 'written') ? _c('span', [_vm._v("\"" + _vm._s(_vm.getCurrentRT.title) + "\"\n          ")]) : _c('span', [_vm._v(" \"" + _vm._s(_vm.getCurrentDiscussion.title) + "\"")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center h-5"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removeStudents),
      expression: "removeStudents"
    }],
    staticClass: "text-red-500 font-medium"
  }, [_vm._v("\n        Removing students will permanently delete all of their activity in the\n        RoundTable.\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 mb-5 mx-auto"
  }, [_c('button', {
    staticClass: "px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-400 font-semibold",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-red-400 rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.disconnectIntegrationCourse
    }
  }, [_vm._v("\n      Disconnect\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7c582148!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/disconnectAssignmentModal.vue
// module id = 999
// module chunks = 61